import { Module } from 'vuex'
import { RootState } from '@/store/index'
import { mutations } from '@/store/modules/order/mutations'
import { IOrderState, initialState } from '@/store/modules/order/state'

export * from '@/store/modules/order/state'

export const store: Module<IOrderState, RootState> = {
  state: initialState,
  mutations
}
